import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import coin from "../assets/images/coin.png";
import "./../Gifts/Gifts.css";
import { HttpService } from "../service/HttpService";
import Constant from "../constant/Constant";
import Header from "../Common/Header/Header";
import AlertComponent from "../Common/Alert/Alert";
import { Link, useHistory } from "react-router-dom";
var QRCode = require("qrcode.react");

const Company = (props) => {
  const httpService = new HttpService();
  const history = useHistory();
  const [voucher, setVoucher] = useState([]);
  const [value, setValue] = useState({ id: "", userId: "" });
  const [alert, setAlert] = useState(false);
  const [redeemOption, setRedeemOption] = useState({});

  const gifts = () => {
    httpService.getApi("vendor").then(
      (response) => {
        setVoucher(response.data.content);
        console.log(response);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  useEffect(() => {
    gifts();
  }, []);

  const { buttonLabel, className } = props;

  const [modal, setModal] = useState(false);
  const [visible, setVisible] = useState(false);

  const toggle = (reward) => {
    // if(localStorage.getItem('balance')<reward.amount){
    //     setAlert(true)
    // }else{
    setModal(true);
    setRedeemOption(reward);
    getUserInfo(reward);
    // }
  };

  const redirect = (view, id) => {
    history.push({
      pathname: view,
      state: { id: id },
    });
  };

  const closeModal = () => {
    setModal(false);
  };

  const closeVisible = () => {
    setVisible(false);
  };

  const onDismiss = () => {
    setAlert(false);
  };

  const getUserInfo = (reward) => {
    let obj = {};
    if (
      localStorage.getItem("user") !== undefined &&
      localStorage.getItem("user") !== null
    ) {
      obj = JSON.parse(localStorage.getItem("user"));

      value.id = reward.id;
      value.userId = obj.userId;
      value.points = reward.amount;

      setValue({ ...value });
    }
  };
  return (
    <>
      <Header />
      {alert && (
        <AlertComponent
          color="danger"
          message="Insufficent balance"
          alert={alert}
          onDismiss={onDismiss}
        />
      )}

      <div className="gifts_sec">
        <Container>
          <h5 style={{ marginTop: "1%", color: "#c94d3d" }}>Our Brands</h5>
          <div className="listings">
            <Row>
              {voucher.map((i) => (
                <Col lg={4} md={6} key={i.id}>
                  <div
                    className="box"
                    style={{ height: "280px" }}
                    onClick={() => redirect("/gifts", i.id)}
                  >
                    <img
                      className="img-fluid"
                      src={Constant.IMAGE_BASE_URl + i.imageUrl}
                      alt="coffe-imgg"
                    />
                    <div className="head">
                      <h5>{i.name}</h5>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
export default Company;
